/**
 * Subtle SVG background patterns for colorblind-friendly differentiation.
 * Larger tile size + thinner strokes + opacity keep the patterns soft.
 * Each returns a CSS `backgroundImage` value.
 */
const PATTERNS: ((color: string) => string)[] = [
  // Diagonal lines (top-left to bottom-right)
  (c) =>
    `url("data:image/svg+xml,%3Csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M-1,1 l2,-2 M0,12 l12,-12 M11,13 l2,-2' stroke='${encodeURIComponent(c)}' stroke-width='0.5' opacity='0.35'/%3E%3C/svg%3E")`,
  // Dots
  (c) =>
    `url("data:image/svg+xml,%3Csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='6' cy='6' r='0.8' fill='${encodeURIComponent(c)}' opacity='0.35'/%3E%3C/svg%3E")`,
  // Horizontal lines
  (c) =>
    `url("data:image/svg+xml,%3Csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0,6 h12' stroke='${encodeURIComponent(c)}' stroke-width='0.5' opacity='0.35'/%3E%3C/svg%3E")`,
  // Crosshatch
  (c) =>
    `url("data:image/svg+xml,%3Csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0,6 h12 M6,0 v12' stroke='${encodeURIComponent(c)}' stroke-width='0.4' opacity='0.3'/%3E%3C/svg%3E")`,
  // Diagonal lines (bottom-left to top-right)
  (c) =>
    `url("data:image/svg+xml,%3Csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M-1,11 l2,2 M0,0 l12,12 M11,-1 l2,2' stroke='${encodeURIComponent(c)}' stroke-width='0.5' opacity='0.35'/%3E%3C/svg%3E")`,
];

export function getPatternStyle(index: number, color: string) {
  const patternFn = PATTERNS[index % PATTERNS.length];
  return { backgroundImage: patternFn(color) };
}
